<template>
  <div id="data-list-list-view" class="data-list-container">
    <CuentaAliadaSidebar v-if="addNewDataSidebar" :propModeCreate="sidebarCreateMode" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <div class="ml-6 mb-3 mt-3">
        <vs-button color="primary" type="border" icon="add" @click="handleCreate()">Crear cuenta aliada</vs-button>
    </div>

    <vs-table :data="aliados" ref="table" noDataText="No hay datos disponibles">
      <!-- <template slot="header">
        <h3>
          ALiados
        </h3>
      </template> -->
      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in table_headers" :sort-key="row.sortKey">
          <p class="product-name font-medium truncate">{{ row.title }}</p>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in aliados" >
          <vs-td :data="data[indextr].idAccount">
            {{data[indextr].idAccount}}
          </vs-td>

          <vs-td :data="data[indextr].description">
            {{data[indextr].description}}
          </vs-td>

          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>

          <vs-td :data="data[indextr].idIdentificationType">
            {{data[indextr].idIdentificationType}}
          </vs-td>

          <vs-td :data="data[indextr].identification">
            {{data[indextr].identification}}
          </vs-td>

          <vs-td :data="data[indextr].country">
            {{data[indextr].country}}
          </vs-td>

          <vs-td :data="data[indextr].state">
            {{data[indextr].state}}
          </vs-td>

          <vs-td :data="data[indextr].city">
            {{data[indextr].city}}
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="Edit3Icon" svgClasses="w-5 h-5 hover:text-dark stroke-current" class="mr-6" @click.stop="handleEdit(data[indextr])"/>
            <feather-icon icon="Trash2Icon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="handleDelete(data[indextr].idAccount)"/>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import FeatherIcon from '../../../components/FeatherIcon.vue'
import { searchCompany, searchCompanyById } from '../../../config/companies.js'
import AliadosModule from '@/store/cuenta-aliada-module/moduleDataList.js'
import CuentaAliadaCreateUpdate from './CuentaAliadaCreateUpdate.vue'
import CuentaAliadaSidebar from './CuentaAliadaSidebar.vue'

export default {
  components: { FeatherIcon, CuentaAliadaCreateUpdate, CuentaAliadaSidebar },
  created () {
    this.company = searchCompany(this.$route.params.nameCompany)
    this.company_id = this.company.idCompany

    if (!AliadosModule.isRegistered) {
      this.$store.registerModule('AliadosModule', AliadosModule)
      AliadosModule.isRegistered = true
    }

    this.getAliados()
  },
  data () {
    return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarCreateMode: true,
      company: null,
      company_id: '',
    }
  },
  computed: {
    aliados(){
      return this.$store.state.AliadosModule.aliados
    },
    table_headers(){
      return this.$store.state.AliadosModule.table_headers
    }
  },
  methods: {
    handleEdit(aliado){
      // console.log(aliado)
      this.sidebarData = aliado
      this.sidebarCreateMode = false
      this.toggleDataSidebar(true)
    },

    handleDelete(idAccount){
      console.log("id aliado: ", idAccount)
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar eliminar`,
        text: '¿Desea eliminar este aliado?',
        acceptText: "Aceptar",
        cancelText: "Cancelar",
        accept: this.deleteAliado.bind(this, idAccount)
      })
    },

    handleCreate(){
      this.sidebarData = {}
      this.sidebarCreateMode = true
      this.toggleDataSidebar(true)
    },

    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if(!val){
        this.getAliados()
      }
    },

    getAliados(){
      this.$vs.loading()
      this.$store.dispatch('AliadosModule/getAllAliados', {
        idCompany: this.company_id
      })
      .then(() => {
        console.log('aliados: ', this.aliados)
        this.$vs.loading.close()
      })
      .catch(() => {
        this.$vs.loading.close()

        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text:
            'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          acceptText: 'Aceptar'
        })
      })
    },

    deleteAliado(idAccount){
      this.$vs.loading()
      this.$store.dispatch('AliadosModule/deleteAliado', idAccount)
      .then((response) => {
        // this.$vs.loading.close()
        this.$vs.dialog({
          color:'success',
          title:'Aviso',
          text:'Aliado eliminado correctamente.',
          accept: this.getAliados()
        })
      })
      .catch(() => {
        this.$vs.loading.close()

        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
          acceptText: 'Aceptar'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
